
      export const versions = {
        commit: '9a2fd82435a88cc6bde6dc91377aa478dbc90807',
        branch: 'HEAD'
      };
